export default "__VITE_ASSET__729c0e0d__"